import { combineStateReducer } from "../utils/combineStateReducer";
import { State, Selector } from "./types";

import * as retrieveOrganizationalUnits from "./retrieveOrganizationalUnits";

import * as retrieveAllOrganizationalUnits from "./retrieveAllOrganizationalUnits";

import * as createOrganizationalUnit from "./createOrganizationalUnit";

import * as editOrganizationalUnit from "./editOrganizationalUnit";

import * as removeOrganizationalUnit from "./removeOrganizationalUnit";

import * as moveOrganizationalUnit from "./moveOrganizationalUnit";

import * as updateOrganizationalUnit from "./updateOrganizationalUnit";

const initialState: State = {
  retrieveOrganizationalUnits: retrieveOrganizationalUnits.initialState,
  retrieveAllOrganizationalUnits: retrieveAllOrganizationalUnits.initialState,
  createOrganizationalUnit: createOrganizationalUnit.initialState,
  editOrganizationalUnit: editOrganizationalUnit.initialState,
  removeOrganizationalUnit: removeOrganizationalUnit.initialState,
  moveOrganizationalUnit: moveOrganizationalUnit.initialState,
  updateOrganizationalUnit: updateOrganizationalUnit.initialState,
};

const reduceState = combineStateReducer(initialState, {
  retrieveOrganizationalUnits: retrieveOrganizationalUnits.reduceState,
  retrieveAllOrganizationalUnits: retrieveAllOrganizationalUnits.reduceState,
  createOrganizationalUnit: createOrganizationalUnit.reduceState,
  editOrganizationalUnit: editOrganizationalUnit.reduceState,
  removeOrganizationalUnit: removeOrganizationalUnit.reduceState,
  moveOrganizationalUnit: moveOrganizationalUnit.reduceState,
  updateOrganizationalUnit: updateOrganizationalUnit.reduceState,
});

function createSelector(getState: () => State): Selector {
  return {
    ...retrieveOrganizationalUnits.createSelector(
      () => getState().retrieveOrganizationalUnits,
    ),
    ...retrieveAllOrganizationalUnits.createSelector(
      () => getState().retrieveAllOrganizationalUnits,
    ),
    ...createOrganizationalUnit.createSelector(
      () => getState().createOrganizationalUnit,
    ),
    ...editOrganizationalUnit.createSelector(
      () => getState().editOrganizationalUnit,
    ),
    ...removeOrganizationalUnit.createSelector(
      () => getState().removeOrganizationalUnit,
    ),
    ...moveOrganizationalUnit.createSelector(
      () => getState().moveOrganizationalUnit,
    ),
    ...updateOrganizationalUnit.createSelector(
      () => getState().updateOrganizationalUnit,
    ),
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
